import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'dss-libs-ui-badge',
  imports: [],
  templateUrl: './badge.component.html',
  styleUrl: './badge.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BadgeComponent {
  readonly text = input.required<string>();
  readonly textAppliedClasses = input<string>('text-primary');
  readonly badgeAppliedClasses = input<string>('bg-primary-ghost');
}
